import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_CHEST_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-barbell-flat-press",
    "name": "杠铃平板卧推",
    "group": "chest",
    "subCategory": "mid-chest",
    "equipment": "barbell",
    "pattern": "平板水平推",
    "legacyIds": [
      "barbell-flat-press",
      "ksw-chest-bench-press-compressed"
    ],
    "sourceId": "course-20261008-four-way-01-03",
    "targetMuscles": [
      "胸大肌",
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-cable-crossover",
    "name": "站姿绳索夹胸",
    "group": "chest",
    "subCategory": "inner-chest",
    "equipment": "cable",
    "pattern": "站姿双臂肩水平内收",
    "legacyIds": [
      "cable-crossover"
    ],
    "sourceId": "course-20261008-four-way-01-05",
    "targetMuscles": [
      "胸大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-push-up",
    "name": "俯卧撑",
    "group": "chest",
    "subCategory": "mid-chest",
    "equipment": "bodyweight",
    "pattern": "闭链水平推",
    "legacyIds": [
      "push-up"
    ],
    "sourceId": "course-20261008-four-way-04-02",
    "targetMuscles": [
      "胸大肌",
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-dumbbell-pushup",
    "name": "哑铃支撑俯卧撑",
    "group": "chest",
    "subCategory": "mid-chest",
    "equipment": "dumbbell",
    "pattern": "哑铃支撑闭链水平推",
    "legacyIds": [
      "home-dumbbell-pushup"
    ],
    "sourceId": "course-20261008-home-01-04",
    "targetMuscles": [
      "胸大肌",
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-dumbbell-flat-press",
    "name": "哑铃地板卧推",
    "group": "chest",
    "subCategory": "mid-chest",
    "equipment": "dumbbell",
    "pattern": "地面仰卧水平推",
    "legacyIds": [
      "home-dumbbell-flat-press"
    ],
    "sourceId": "course-20261008-home-01-03",
    "targetMuscles": [
      "胸大肌",
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-dumbbell-fly",
    "name": "哑铃地板飞鸟",
    "group": "chest",
    "subCategory": "inner-chest",
    "equipment": "dumbbell",
    "pattern": "地面仰卧肩水平内收",
    "legacyIds": [
      "home-dumbbell-fly"
    ],
    "sourceId": "course-20261008-home-01-05",
    "targetMuscles": [
      "胸大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-dips",
    "name": "辅助双杠臂屈伸",
    "group": "chest",
    "subCategory": "lower-chest",
    "equipment": "machine",
    "pattern": "辅助双杠闭链推",
    "legacyIds": [
      "ksw-dips",
      "threeway-dips"
    ],
    "sourceId": "course-20261008-personal-04-02",
    "targetMuscles": [
      "胸大肌下部",
      "肱三头肌"
    ],
    "evidence": "新私教、凯圣王与旧三分化均可见辅助平台；旧bodyweight元数据纠正，只改标准库",
    "isBodyweight": true
  },
  {
    "id": "library-threeway-machine-fly",
    "name": "坐姿器械夹胸",
    "group": "chest",
    "subCategory": "inner-chest",
    "equipment": "machine",
    "pattern": "坐姿双臂肩水平内收",
    "legacyIds": [
      "threeway-machine-fly"
    ],
    "sourceId": "course-20261008-fanjue-plan-11-04",
    "targetMuscles": [
      "胸大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-flat-machine-press",
    "name": "平板器械卧推",
    "group": "chest",
    "subCategory": "mid-chest",
    "equipment": "machine",
    "pattern": "器械水平推",
    "legacyIds": [
      "threeway-flat-machine-press",
      "personal-s4-seated-flat-press"
    ],
    "sourceId": "course-20261008-personal-04-03",
    "targetMuscles": [
      "胸大肌",
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-decline-cable-fly",
    "name": "站姿绳索下胸夹胸",
    "group": "chest",
    "subCategory": "lower-chest",
    "equipment": "cable",
    "pattern": "高位向下肩内收",
    "legacyIds": [
      "threeway-decline-cable-fly"
    ],
    "sourceId": "threeway-decline-cable-fly",
    "targetMuscles": [
      "胸大肌下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s4-cable-upper-chest",
    "name": "站姿绳索上胸夹胸",
    "group": "chest",
    "subCategory": "upper-chest",
    "equipment": "cable",
    "pattern": "低位向上肩内收",
    "legacyIds": [
      "personal-s4-cable-upper-chest"
    ],
    "sourceId": "course-20261008-personal-04-05",
    "targetMuscles": [
      "胸大肌上部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-incline-barbell-press",
    "name": "上斜史密斯卧推",
    "group": "chest",
    "subCategory": "upper-chest",
    "equipment": "machine",
    "pattern": "史密斯上斜推",
    "legacyIds": [
      "fanjue-incline-barbell-press",
      "fanjue-incline-smith-press"
    ],
    "sourceId": "course-20261008-fanjue-plan-11-02",
    "targetMuscles": [
      "胸大肌上部",
      "三角肌前束",
      "肱三头肌"
    ],
    "evidence": "第9期源是史密斯，不是自由杠铃；第11期已使用同老师正确史密斯素材"
  }
];
